import * as React from 'react';
import { ICoreContext, Image } from '@msdyn365-commerce/core';
import { IGridSettings } from '@msdyn365-commerce/core-internal';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { getFallbackImageUrl, getProductUrlSync } from '@msdyn365-commerce-modules/retail-actions';

export interface IProductCard {
  recId: number;
  itemId: string;
  name: string;
  description: string;
  img: string;
  callback: any;
  mobileMode: boolean;
  context: ICoreContext;
  gridSettings: IGridSettings;
  product: SimpleProduct;
  enablePrice?: boolean;
  eshopUrlPrefix?: string;
}

/**
 *
 * ProductCard component
 * @extends {React.PureComponent<IProductCard>}
 */
export class ProductCard extends React.PureComponent<IProductCard> {
  public render(): JSX.Element | null {
    const cardStyle = 'eshop-product-card';

    return (
      <div className={cardStyle}>
        {this._renderImage()}
        {this._renderInfo()}
      </div>
    );
  }

  private _renderImage(): JSX.Element | null {
    return (
      <div className='img-wrapper' onClick={this._handleOnClick}>
        <Image
          src={this.props.img || ''}
          fallBackSrc={getFallbackImageUrl(this.props.itemId, this.props.context.actionContext.requestContext.apiSettings)}
          altText={this.props.name}
          gridSettings={this.props.gridSettings}
          loadFailureBehavior='empty'
        />
      </div>
    );
  }

  private _renderInfo(): JSX.Element | null {
    const PriceStyle = this.props.enablePrice ? 'price' : 'no-display';
    // const nameStyle = {maxWidth: Math.round(window.innerWidth / 7) };

    return (
      <div className='content-wrapper'>
        <p className='name ellipsis' /*style={nameStyle}*/>{this.props.name}</p>
        <p className={PriceStyle}>${this.props.product.Price}</p>
      </div>
    )
  }

  private _handleOnClick = () => {
    event?.preventDefault();

    if (typeof window !== 'undefined') {
      window.location.assign(this.props.eshopUrlPrefix + getProductUrlSync(this.props.product, this.props.context.actionContext, undefined));
    }
  }
}

export default ProductCard;